import { getEnvironmentConfig } from "./getEnvironmentConfig";

const forge = require("node-forge");

const keyBytesString = getEnvironmentConfig("DI_KEY"); // Replace with your key

export function decryptDirectIntegrationPayload(cipherText) {
  const keyBytes = forge.util.createBuffer(keyBytesString, "utf8").getBytes();
  const iv = forge.util.createBuffer(keyBytesString, "utf8").getBytes();

  const decrypted = decryptStringFromBytes(cipherText, keyBytes, iv);
  return decrypted;
}

function decryptStringFromBytes(cipherText, key, iv) {
  if (!cipherText || cipherText.length === 0) {
    throw new Error("cipherText cannot be null or empty");
  }
  if (!key || key.length === 0) {
    throw new Error("key cannot be null or empty");
  }
  if (!iv || iv.length === 0) {
    throw new Error("iv cannot be null or empty");
  }

  try {
    const encryptedBytes = forge.util.decode64(cipherText);
    const decipher = forge.cipher.createDecipher("AES-CBC", key);
    decipher.start({ iv: iv });
    decipher.update(forge.util.createBuffer(encryptedBytes));
    const success = decipher.finish();

    if (!success) {
      throw new Error("Decryption failed due to invalid data or padding.");
    }

    return decipher.output.toString("utf8");
  } catch (error) {
    throw new Error(`Decryption failed: ${error.message}`);
  }
}
